import { createApp } from 'vue'
import './assets/css/site.css'
import Main from './Main.vue'
import router from './router'
import DropdownDirective from '@ui/directives/dropdown-toggle'
import formValidation from '@ui/form-validation/form-validation'
import InfiniteScroll from "@ui/directives/infinite-scroll";
import PDFObjectPlugin from 'pdfobject-vue';
import MaskPlugin from '@ui/phone-mask/useMask';
import { lookup } from "@/main-store"

createApp(Main)
    .use(router)
    .use(PDFObjectPlugin)
    .use(MaskPlugin)
    .directive('form', formValidation)
    .directive('dropdown-toggle', DropdownDirective)
    .directive("infinite-scroll", InfiniteScroll)
    .provide('lookup', lookup)
    .mount('#app')
